import { useQuery } from "@tanstack/react-query";
import { getMyDrafts } from "../actions/getMyDrafts.actions";

export const useGetMyDraftsQuery = () => {
    const query = useQuery<any>({
        queryKey: ["page-builder-my-drafts"],
        queryFn: () => getMyDrafts(),
        staleTime: 0,
        gcTime: 5 * 60 * 1000,
    });

    return query;
};